<div class="main-container" *ngIf="someUdfToRender">

    <div class="header" *ngIf="Title">
      {{ Title }}
    </div>
  
  <form class="udf" [formGroup]="renderedUdfsForm" *ngIf="renderedUdfsFormHasControls" >
      <div *ngFor="let udf of Udfs" >
        <ng-container *ngIf="udf.IsRendered">
          <!--################################# Fecha ###################################-->
          <mat-form-field appearance="outline" *ngIf="udf.FieldType === 'DateTime'"
            [matTooltip]="udf.Name"
            matTooltipPosition="above"
            class="width-100"
            style="margin-bottom: -0.7em;"
            matTooltipTouchGestures="off">
            <mat-label>{{udf.Description}}</mat-label>
            <input matInput [matDatepicker]="datepicker"
                   [formControlName]="udf.Name"
              (dateChange)="OnUdfValueChange($event, udf)">
            <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
            <mat-datepicker #datepicker>
              <mat-datepicker-actions>
                <button mat-button matDatepickerCancel>Cancelar</button>
                <button mat-raised-button color="primary" matDatepickerApply>Ok</button>
              </mat-datepicker-actions>
            </mat-datepicker>
          </mat-form-field>
  
  
          <!--################################# Texto ##################################-->
          <mat-form-field appearance="outline" *ngIf="udf.FieldType === 'String' && (!udf.ParsedValues || (udf.ParsedValues && !udf.ParsedValues.length))"
            [matTooltip]="udf.Name"
            matTooltipPosition="above"
            class="width-100"
            style="margin-bottom: -0.7em;"
            matTooltipTouchGestures="off"
          >
            <mat-label>{{udf.Description}}</mat-label>
            <input matInput type="text" [formControlName]="udf.Name" (change)="OnUdfValueChange($event, udf)" appKeyboardInput>
          </mat-form-field>
  
  
          <!--################################ Number ##################################-->
          <mat-form-field appearance="outline" *ngIf="udf.FieldType === 'Int32' || udf.FieldType === 'Double'"
            [matTooltip]="udf.Name"
            matTooltipPosition="above"
            class="width-100"
            style="margin-bottom: -0.7em;"
            matTooltipTouchGestures="off"
          >
            <mat-label>{{udf.Description}}</mat-label>
            <input matInput [formControlName]="udf.Name" (change)="OnUdfValueChange($event, udf)" appKeyboardInput appJustNumbers>
          </mat-form-field>
  
  
  
          <!--############################### Combo box #################################-->
          <mat-form-field appearance="outline" *ngIf="udf.FieldType === 'String' && udf.ParsedValues && udf.ParsedValues.length && !udf.IsTypehead"
            [matTooltip]="udf.Name"
            matTooltipPosition="above"
            class="width-100"
            style="margin-bottom: -0.7em;"
            matTooltipTouchGestures="off"
          >
            <mat-label>{{udf.Description}}</mat-label>
            <mat-select (selectionChange)="OnUdfValueChange($event, udf)" [formControlName]="udf.Name">
              <mat-option *ngFor="let value of udf.ParsedValues" [value]="value.Value">{{value.Description}}</mat-option>
            </mat-select>
          </mat-form-field>
  
  
  
          <!--################################ Typehead #################################-->
          <mat-form-field class="width-100"
                          appearance="outline"
                          *ngIf="udf.FieldType === 'String' && udf.ParsedValues && udf.ParsedValues.length && udf.IsTypehead"
                          style="margin-bottom: -0.7em;">
  
            <mat-label>{{udf.Description}}</mat-label>
            <input type="text"
                   matInput
                   [matAutocomplete]="auto"
                   [formControlName]="udf.Name"
                   (click)="SetFilteredOptions(udf)"
                   (focus)="SetFilteredOptions(udf)"
                   [matTooltip]="udf.Name"
                   matTooltipPosition="above" appKeyboardInput>
            <mat-autocomplete autoActiveFirstOption [displayWith]="AutoCompleteDisplay" #auto="matAutocomplete" (optionSelected)="OnUdfValueChange($event, udf)">
              <mat-option *ngFor="let value of filteredTypeheadOptions" [value]="value"
                matTooltip="{{value.Value}} - {{value.Description}}"
                          matTooltipTouchGestures="off"
                matTooltipPosition="right">
                {{value.Value}} - {{value.Description}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
  
        </ng-container>
      </div>
  </form>
  </div>
  